module.exports = __webpack_public_path__ + "static/media/ZEN-1.629de3e6.JPG";